import { useEffect, useState } from "react";
import { useScreenOrientation } from "../../hooks/useScreenOrientation";
import { useComponentLoadingStateStore } from "../../store/useComponentLoadingStateStore";
import { Slide, Typography } from "@mui/material";
import Image from "next/image";
import {
  MobileIndicatorsAlert,
  MobileIndicatorsSnackbar,
  RotatePhoneAnimationWrapper,
  SwipeHandAnimationWrapper,
} from "./Styled-Components/MobileIndicatorsStyled";

const SlideAnimation = (props: any) => {
  return <Slide {...props} direction="right" />;
};

const MobileIndicators = () => {
  const { isExpoPageLoaded, hasUserSwiped } = useComponentLoadingStateStore();
  const { portrait } = useScreenOrientation();
  const [isMobileDevice, setIsMobileDevice] = useState<null | boolean>(null);
  const [open, setOpen] = useState(false);
  const [isFirstRender, setIsFirstRender] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const isMobileOrTablet =
      /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|Tablet|Kindle/i.test(
        navigator.userAgent
      );
    isMobileOrTablet ? setIsMobileDevice(true) : setIsMobileDevice(false);
  }, [portrait]);

  useEffect(() => {
    if (isMobileDevice && isExpoPageLoaded && isFirstRender) {
      setTimeout(() => {
        setOpen(true);
      }, 3000);
      setTimeout(() => {
        handleClose();
      }, 8000);
      setIsFirstRender(false);
    }
  }, [isExpoPageLoaded, isFirstRender, isMobileDevice]);

  return (
    <>
      <MobileIndicatorsSnackbar
        open={portrait ? open : false}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        TransitionComponent={SlideAnimation}
      >
        <MobileIndicatorsAlert
          onClose={handleClose}
          icon={
            <RotatePhoneAnimationWrapper className="rotate-phone-icon">
              <Image
                src="/rotate-mobile.svg"
                width={48}
                height={48}
                alt="rotate phone icon"
              />
            </RotatePhoneAnimationWrapper>
          }
        >
          <Typography fontWeight="bold" textAlign="center" px={1}>
            For better experience!
          </Typography>
        </MobileIndicatorsAlert>
      </MobileIndicatorsSnackbar>
      {!hasUserSwiped && isMobileDevice && (
        <>
          <SwipeHandAnimationWrapper className="swipe-screen-icon">
            <Image
              src="/swipe-icon.svg"
              width={64}
              height={64}
              alt="swipe icon"
            />
          </SwipeHandAnimationWrapper>
        </>
      )}
    </>
  );
};

export default MobileIndicators;
